<template>
  <v-text-field
    dense
    :messages="errors.length ? errors : []"
    v-model="value"
    :label="$t('Enter code')"
    :append-outer-icon="checkResult ? 'mdi-check' : 'mdi-refresh'"
    :loading="waiting"
  >
    <template v-slot:append-outer>
      <v-btn small tile @click="checkPromoCode" color="success"
        >{{$t('Activate')}}</v-btn
      >
    </template>
  </v-text-field>
</template>

<script>
const axios = require("axios").default;

export default {
  props: {
    link: String,
    questId: Number,
    date: String,
    time: String,
    price: Number,
  },
  data: function () {
    return {
      waiting: false,
      checkResult: "",
      value: "",
    };
  },
  computed: {
    errors() {
      if (this.checkResult === false && !this.text) {
        return [this.$t("Wrong code")];
      }
      if (this.text) {
        return [this.text];
      }
      return [];
    },
  },
  methods: {
    checkPromoCode() {
      this.value = this.value.split(" ").join("");
      this.waiting = true;
      this.text = "";
      var data = {
        code: this.value,
        quest_id: this.questId,
        date: this.date,
        time: this.time,
        price: this.price,
      };
      axios
        .post(this.link, data)
        .then((response) => {
          if (response.data.success) {
            this.checkResult = response.data.data.result;
            this.waiting = false;
            this.text = response.data.data.text;
            // eslint-disable-next-line no-console
            this.$emit(
              "checkSuccessfull",
              this.value,
              response.data.data.change_type,
              response.data.data.value,
              response.data.data.id,
              response.data.data.text
            );
          }
        })
        .catch(() => {
          this.text = this.$t("Error");
          this.checkResult = false;
          this.waiting = false;
        });
    },
  },
};
</script>